function Nicaragua({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1771)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0Z" fill="#338AF3"/>
  <path d="M16 31.9996C22.3433 31.9996 27.8244 28.308 30.4124 22.9561H1.58765C4.17565 28.308 9.65664 31.9996 16 31.9996Z" fill="#338AF3"/>
  <path d="M16.0001 11.1309C13.3107 11.1309 11.1305 13.311 11.1305 16.0004C11.1305 18.6898 13.3107 20.87 16.0001 20.87C18.6894 20.87 20.8696 18.6898 20.8696 16.0004C20.8696 13.311 18.6894 11.1309 16.0001 11.1309ZM16.0001 18.783C14.4633 18.783 13.2174 17.5373 13.2174 16.0004C13.2174 14.4635 14.4632 13.2178 16.0001 13.2178C17.5369 13.2178 18.7827 14.4635 18.7827 16.0004C18.7827 17.5373 17.5368 18.783 16.0001 18.783Z" fill="#FFDA44"/>
  <path d="M18.4099 16.6956L16 16L13.5901 16.6956L12.7869 18.0869H19.2131L18.4099 16.6956Z" fill="#0052B4"/>
  <path d="M16 12.5215L14.3934 15.3041L16 15.9997L17.6066 15.3041L16 12.5215Z" fill="#338AF3"/>
  <path d="M13.5901 16.6959H18.4098L17.6065 15.3047H14.3934L13.5901 16.6959Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Nicaragua;
